import { create } from 'zustand';

export type Section =
  | 'jour'
  | 'planning'
  | 'eleves'
  | 'previsions'
  | 'absences'
  | 'factures'
  | 'tableau'
  | 'messages'
  | 'vehicules'
  | 'support';

interface BilanTarget {
  candidateId: string;
  candidateName: string;
  lessonId?: string;
  /** Début de la leçon désignée : avant, le résumé ne s'enregistre pas (livret et notes, oui). */
  lessonStartsAt?: string;
}

interface UiState {
  section: Section;
  /** Change de rubrique ; referme les pages de travail ouvertes (livret et résumé de la séance, évaluation). */
  setSection: (s: Section) => void;

  /** Élève à présélectionner dans « Prévisions » (ouvert depuis sa fiche). */
  forecastCandidateId: string | null;
  openForecast: (candidateId: string) => void;
  clearForecast: () => void;

  /** Livret et résumé de la séance (une seule page depuis le 30/10/2026). */
  bilanTarget: BilanTarget | null;
  openBilan: (target: BilanTarget) => void;
  closeBilan: () => void;

  evalStudentId: string | null;
  openEvaluation: (id: string) => void;
  closeEvaluation: () => void;

  lessonsStudent: { id: string; name: string } | null;
  openLessons: (id: string, name: string) => void;
  closeLessons: () => void;

  /** Signalement d'un dégât sur un véhicule de l'école ; `vehicleId` choisi d'office, sinon celui de la leçon. */
  damageReport: { vehicleId?: string } | null;
  openDamageReport: (vehicleId?: string) => void;
  closeDamageReport: () => void;

  /** Tableau en plein écran, par-dessus la rubrique ou la page ouverte (un bilan reste intact dessous). */
  boardOpen: boolean;
  openBoard: () => void;
  closeBoard: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  section: 'jour',
  setSection: (section) => set({ section, bilanTarget: null, evalStudentId: null }),

  forecastCandidateId: null,
  openForecast: (forecastCandidateId) =>
    set({ section: 'previsions', forecastCandidateId, bilanTarget: null, evalStudentId: null }),
  clearForecast: () => set({ forecastCandidateId: null }),

  bilanTarget: null,
  openBilan: (bilanTarget) => set({ bilanTarget }),
  closeBilan: () => set({ bilanTarget: null }),

  evalStudentId: null,
  openEvaluation: (evalStudentId) => set({ evalStudentId }),
  closeEvaluation: () => set({ evalStudentId: null }),

  lessonsStudent: null,
  openLessons: (id, name) => set({ lessonsStudent: { id, name } }),
  closeLessons: () => set({ lessonsStudent: null }),

  damageReport: null,
  openDamageReport: (vehicleId) => set({ damageReport: { vehicleId } }),
  closeDamageReport: () => set({ damageReport: null }),

  boardOpen: false,
  openBoard: () => set({ boardOpen: true }),
  closeBoard: () => set({ boardOpen: false }),
}));
